import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, CardActionArea, Typography, Stack, Button } from '@mui/material';
import { FaNewspaper } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { fetchAllNews } from '../../controllers/newsController';
import { resolveNewsAssetUrl } from '../../api/httpClientNews';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Haberler = () => {
    const navigate = useNavigate();
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError('');
        fetchAllNews({ pageNumber: 1, pageSize: 5 })
            .then(({ data }) => {
                if (!active) return;
                setNews(Array.isArray(data) ? data : []);
            })
            .catch((e) => {
                if (active) setError(e?.message || 'Haberler alınamadı');
            })
            .finally(() => {
                if (active) setLoading(false);
            });
        return () => {
            active = false;
        };
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const months = [
            'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
            'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
        ];
        return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    };

    return (
        <Card sx={{ flex: '0 0 calc(50% - 16px)', minWidth: 300, border: '1px solid #f1f1f1', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
            <CardContent sx={{ p: 2.5 }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                    <Stack direction="row" alignItems="center" spacing={1.5}>
                        <Box
                            sx={{
                                width: 44,
                                height: 44,
                                borderRadius: '50%',
                                backgroundColor: '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <FaNewspaper style={{ fontSize: '18px', color: '#0E4D94' }} />
                        </Box>
                        <Typography sx={{ fontSize: '18px', fontWeight: 500, color: '#444444' }}>
                            Son Haberler
                        </Typography>
                    </Stack>
                    <Button
                        variant="text"
                        size="small"
                        onClick={() => navigate('/news')}
                        sx={{
                            textTransform: 'none',
                            fontSize: '13px',
                            fontWeight: 500,
                            backgroundColor: 'transparent',
                            color: '#0E4D94',
                            textDecoration: 'underline',
                            '&:hover': {
                                backgroundColor: 'transparent',
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        Tüm Haberler
                    </Button>
                </Stack>

                {error ? (
                    <Typography color="error" sx={{ fontSize: '14px' }}>{error}</Typography>
                ) : loading ? (
                    <Stack spacing={1.5}>
                        {Array.from({ length: 4 }).map((_, index) => (
                            <Card
                                key={`skeleton-${index}`}
                                sx={{
                                    width: '100%',
                                    border: 'none',
                                    boxShadow: 'none',
                                    borderRadius: '8px',
                                }}
                            >
                                <CardActionArea sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', p: 1 }}>
                                    <Skeleton width={120} height={80} borderRadius={4} />
                                    <Box sx={{ flex: 1, ml: 1.5 }}>
                                        <Skeleton width={100} height={14} style={{ marginBottom: 8 }} />
                                        <Skeleton width="90%" height={18} />
                                    </Box>
                                    <Skeleton width={20} height={20} />
                                </CardActionArea>
                            </Card>
                        ))}
                    </Stack>
                ) : news.length === 0 ? (
                    <Typography sx={{ fontSize: '14px', color: '#a3a3a3', textAlign: 'center', py: 2 }}>
                        Henüz haber bulunmamaktadır.
                    </Typography>
                ) : (
                    <Stack spacing={1.5}>
                        {news.map((item) => (
                            <CardActionArea
                                key={item.id}
                                onClick={() => navigate(`/news/${item.id}`)}
                                sx={{
                                    borderRadius: '8px',
                                    '&:hover': {
                                        backgroundColor: '#f9f9f9',
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1.5,
                                        p: 1,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 120,
                                            height: 80,
                                            borderRadius: '4px',
                                            overflow: 'hidden',
                                            flexShrink: 0,
                                            backgroundColor: '#f5f5f5',
                                        }}
                                    >
                                        {item.coverImageUrl ? (
                                            <Box
                                                component="img"
                                                src={resolveNewsAssetUrl(item.coverImageUrl)}
                                                alt={item.title}
                                                sx={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                }}
                                            />
                                        ) : (
                                            <Box
                                                sx={{
                                                    width: '100%',
                                                    height: '100%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: '#f5f5f5',
                                                }}
                                            />
                                        )}
                                    </Box>
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                        <Typography sx={{ fontSize: '12px', color: '#666666', mb: 0.5 }}>
                                            {formatDate(item.createdAtUtc)}
                                        </Typography>
                                        <Typography sx={{ fontSize: '15px', fontWeight: 600, color: '#1a1a1a', lineHeight: 1.3 }}>
                                            {item.title}
                                        </Typography>
                                    </Box>
                                    <ChevronRightIcon sx={{ fontSize: 20, color: '#0E4D94', flexShrink: 0 }} />
                                </Box>
                            </CardActionArea>
                        ))}
                    </Stack>
                )}
            </CardContent>
        </Card>
    );
};

export default Haberler;
